var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"YiyingMarquee",on:{"mouseenter":_vm.onMouseenter,"mouseleave":_vm.onMouseleave}},[_c('div',{ref:"marquee1",staticClass:"item"},[_c('img',{attrs:{"src":_vm.url}})]),_c('div',{ref:"marquee2",staticClass:"item"},[_c('img',{attrs:{"src":_vm.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }